import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom";

// ** Router Components
import { BrowserRouter } from "react-router-dom";



// ** I18nextProvider Imports &  i18n config
import { I18nextProvider } from "react-i18next";
import i18n from "./configs/i18n";

// ** import all App Hooks provider
import AppHooksProviders from "./hooks/AppHooksProviders";

// ** React Toastify Style
import "./@core/scss/plugins/toastify/toastify.scss";

// ** Core styles
// import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";

import reportWebVitals from "./reportWebVitals";
import Splash from "./components/Splash";

// ** Lazy load app
const LazyApp = lazy(() => import("./App"));

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
        <BrowserRouter>
          <Suspense fallback={<Splash />}>
            <AppHooksProviders>
              <LazyApp />
            </AppHooksProviders>
          </Suspense>
        </BrowserRouter>
      {/* </LocalizationProvider> */}
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
